var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{class:[
    'm-0 w-100',
    _vm.$style.alert,
    _vm.isCenter && 'd-flex flex-column' ],attrs:{"show":"","variant":_vm.variant}},[_c('font-awesome-icon',{class:_vm.$style.icon,attrs:{"icon":"exclamation-triangle","size":_vm.isCenter ? '2x' : 'lg'}}),_c('div',{class:[
      _vm.isCenter && 'pt-4 text-center',
      _vm.$style.content
    ]},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }